import axios from "axios";

export default {
  namespaced: true,
  state: {
    viralContentResponse: {},
    igMedia: [],
    igMediaSortedAndFiltered: [],
  },
  mutations: {
    viral_finder_request_success(state, viralContentResponse) {
      //TODO: set ui state
      state.status = "success";
      state.viralContentResponse = viralContentResponse;
      state.igMedia = viralContentResponse.business_discovery.media.data;
    },
    sort_ig_media(state, sortBy) {
      let media = state.igMedia;

      switch (sortBy) {
        case "likes":
          media.sort(function(a, b) {
            return parseFloat(b.like_count) - parseFloat(a.like_count);
          });
          break;
        case "comments":
          media.sort(function(a, b) {
            return parseFloat(b.comments_count) - parseFloat(a.comments_count);
          });
          break;
        case "engagement":
          media.sort(function(a, b) {
            return parseFloat(
              Number(
                (
                  ((b.like_count + b.comments_count) /
                    state.viralContentResponse.business_discovery
                      .followers_count) *
                  100
                ).toFixed(1)
              ) -
                parseFloat(
                  Number(
                    (
                      ((a.like_count + a.comments_count) /
                        state.viralContentResponse.business_discovery
                          .followers_count) *
                      100
                    ).toFixed(1)
                  )
                )
            );
          });
          break;

        default:
          media.sort(function(a, b) {
            return parseFloat(b.like_count) - parseFloat(a.like_count);
          });
          break;
      }

      state.igMediaSortedAndFiltered = media;
    },
    filter_ig_media_by_engagement(state, engagementMultiplier) {
      if (engagementMultiplier == 1) {
        state.igMediaSortedAndFiltered = state.igMedia;
        return;
      }
      let avgEngagement = 0;
      state.igMedia.forEach((mediaEntry) => {
        avgEngagement += mediaEntry.like_count + mediaEntry.comments_count;
      });
      avgEngagement = avgEngagement / state.igMedia.length;

      let media = [];
      state.igMedia.forEach((mediaEntry) => {
        const engagement = mediaEntry.like_count + mediaEntry.comments_count;
        if (engagement > engagementMultiplier * avgEngagement) {
          media.push(mediaEntry);
        }
      });
      state.igMediaSortedAndFiltered = media;
    },
    filter_ig_media_by_type(state, payload) {
      const media = [];
      state.igMediaSortedAndFiltered.forEach((mediaEntry) => {
        switch (mediaEntry.media_type) {
          case "IMAGE":
            if (payload.includeImages) {
              media.push(mediaEntry);
            }
            break;
          case "VIDEO":
            if (payload.includeVideos) {
              media.push(mediaEntry);
            }
            break;
          case "CAROUSEL_ALBUM":
            if (payload.includeCarousel) {
              media.push(mediaEntry);
            }
            break;
        }
      });

      state.igMediaSortedAndFiltered = media;
    },
  },
  actions: {
    findViralContent({ commit }, username) {
      return new Promise((resolve, reject) => {
        //commit("request");
        axios({
          url: "/instagram/find/" + username.username,
          method: "GET",
        })
          .then((resp) => {
            const viralContentResponse = resp.data;
            commit("viral_finder_request_success", viralContentResponse);
            commit("sort_ig_media", "engagement");
            resolve(resp);
          })
          .catch((err) => {
            //commit("viral_finder_request_error", err);
            //localStorage.removeItem("token");
            reject(err);
          });
      });
    },
  },
  getters: {
    igResults: (state) => state.viralContentResponse,
    igMedia: (state) => state.igMediaSortedAndFiltered,
  },
};
